'use client';

import AdminModeBanner from '@/features/notification/components/AdminModeBanner/AdminModeBanner';
import SiteNotification from '@/features/notification/components/SiteNotification/SiteNotification';
import type { SiteNotificationItem } from '@/features/notification/types';
import CommonNavigationBar from '../CommonNavigationBar/CommonNavigationBar';
import styles from './CommonHeader.module.scss';

function CommonHeader({
  cartCount = 0,
  navButtonDispFlg = true,
  latestNotification,
  isStaff = false,
}: {
  cartCount?: number;
  navButtonDispFlg?: boolean;
  latestNotification?: SiteNotificationItem[];
  isStaff?: boolean;
}) {
  return (
    <header className={`${styles.componentStyle} ${isStaff ? styles.componentStyleWithAdminMode : ''}`}>
      {isStaff && <AdminModeBanner />}
      {latestNotification && latestNotification.length > 0 && (
        <SiteNotification link={latestNotification[0].link} title={latestNotification[0].title} />
      )}
      <div className={styles.navigationBar}>
        <CommonNavigationBar navButtonDispFlg={navButtonDispFlg} cartCount={cartCount} />
      </div>
    </header>
  );
}

export default CommonHeader;
